// extracted by mini-css-extract-plugin
export default {"error":"ValidationError_error__t+CzH"};